let importedTemplateSettings = null;

export function changeTemplateSettings(settingsName, newValue) {
    const templateSettings = require('./templateSettings').default;
    if (JSON.stringify(templateSettings[settingsName]) !== JSON.stringify(newValue)) {
        templateSettings[settingsName] = newValue;
    }

    const newTemplateSettings = templateSettings;
    localStorage.setItem('onlineCreatorB2B-settings', JSON.stringify(newTemplateSettings));
}

export function getDefaultTemplateSettings(settingsName) {
    const templateSettings = require('./templateSettings').default;
    return templateSettings[settingsName];
}

export function getImportedTemplateSettingsObject() {
    importedTemplateSettings = JSON.parse(localStorage.getItem('onlineCreatorB2B-settings'));
}

export function getImportedTemplateSettings(settingsName) {
    return importedTemplateSettings[settingsName];
}